import { render } from "./FormacoesView.vue?vue&type=template&id=d86dd7dc&scoped=true"
import script from "./FormacoesView.vue?vue&type=script&lang=js"
export * from "./FormacoesView.vue?vue&type=script&lang=js"

import "./FormacoesView.vue?vue&type=style&index=0&id=d86dd7dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d86dd7dc"]])

export default __exports__